import { render, staticRenderFns } from "./DynamicDataFields.vue?vue&type=template&id=a9b76654&"
import script from "./DynamicDataFields.vue?vue&type=script&lang=ts&"
export * from "./DynamicDataFields.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicDataFields.vue?vue&type=style&index=0&id=a9b76654&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports